import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled from 'styled-components'
import { ContentWidth, TextWidth } from '@ta-interaktiv/react-disco-grid'
import { GlobalVariables } from 'Globals/GlobalVariables'
import { MapBoxMap } from 'components/MapboxMap'
import { useState } from 'react'
import Slider from 'components/Slider'
import { de, fr } from 'Locale/locale'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const [currentTemperatureIndex, setCurrentTemperatureIndex] = useState(4)
  const locale = tenant.lang === 'fr' ? fr : de
  return (
    <AppContainer $colorMode={colorMode}>
      <TextWidth>
        <Title>{locale.title}</Title>
        <Lead>{locale.lead}</Lead>
      </TextWidth>
      <ContentWidth>
        <MapBoxMap
          lang={tenant.lang}
          colorMode={colorMode}
          currentTemperatureIndex={currentTemperatureIndex}
        />
        <TemperatureSliderWrapper>
          <IntroSentence>{locale.introSentence}</IntroSentence>
          <CurrentTemperature>
            {locale.temperatureLabels[currentTemperatureIndex].temp}
            <br />
            <small>
              (
              {
                locale.temperatureLabels[currentTemperatureIndex]
                  .probabilitySentence
              }
              )
            </small>
          </CurrentTemperature>
          <TemperatureLabelsWrapper>
            {locale.temperatureLabels.map((labelEl, index) => {
              return (
                <TemperatureLabel
                  key={index}
                  isActive={index === currentTemperatureIndex}
                >
                  {labelEl.temp.replace('°C', '')}
                </TemperatureLabel>
              )
            })}
          </TemperatureLabelsWrapper>
          <Slider
            type='range'
            min='0'
            max={locale.temperatureLabels.length - 1}
            value={currentTemperatureIndex}
            step='1'
            onChange={(e) => {
              setCurrentTemperatureIndex(Number(e.target.value))
            }}
          />
          <p>{locale.temperatureLabels[currentTemperatureIndex].description}</p>
        </TemperatureSliderWrapper>
      </ContentWidth>
    </AppContainer>
  )
}

const Title = styled.h4`
  line-height: 1.2em;
  margin: 0;
  margin-top: 15px;
  margin-bottom: 4px;
`
const Lead = styled.div`
  font-size: 15px;
  margin-bottom: 15px;
  line-height: 1.4em;
`

const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  margin-bottom: 4rem;
  @media (min-width: 768px) {
    margin-bottom: 18rem;
  }
`
const TemperatureSliderWrapper = styled.div`
  text-align: center;
  line-height: 1;
  padding-top: 0.5em;
  padding-left: 1em;
  padding-right: 1em;
  border-radius: 0.5em;
  font-size: 0.75em;
  @media (min-width: 768px) {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%) translateY(50%);
  }
  background: var(--modal-background);
  /* backdrop-filter: blur(10px); */
  box-shadow: rgba(0, 0, 0, 0.03) 0px 4.5px 1.3px,
    rgba(0, 0, 0, 0.035) 0px 8.6px 3.1px, rgba(0, 0, 0, 0.035) 0px 12.7px 5.5px,
    rgba(0, 0, 0, 0.04) 0px 17.3px 9.2px, rgba(0, 0, 0, 0.04) 0px 23.4px 15.1px,
    rgba(0, 0, 0, 0.047) 0px 33.5px 26.4px, rgba(0, 0, 0, 0.07) 0px 60px 57px;
  display: flex;
  flex-direction: column;
  min-width: 300px;
  z-index: 10;

  /* b {
    white-space: nowrap;
    font-size: 2.5em;
    margin-bottom: 0.5em;
  } */
  p {
    /* max-width: 300px; */
    b {
      white-space: nowrap;
    }
    @media (min-width: 768px) {
      font-size: 1.1em;
    }
    font-size: 1.2em;
    line-height: 1.2;
  }
`
const CurrentTemperature = styled.b`
  white-space: nowrap;
  font-size: 2.5em;
  margin-bottom: 0.5em;
  small {
    font-size: 0.5em;
    /* opacity: 0.5; */
  }
`
const TemperatureLabelsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5em;
  font-size: 0.7em;
  padding: 0 0.7em;
`
const TemperatureLabel = styled.span<{ isActive: boolean }>`
  opacity: ${({ isActive }) => (isActive ? '1' : '.5')};
  line-height: 1;
`
const IntroSentence = styled.p`
  opacity: 0.5;
`
export default MainComponent
